import { render, staticRenderFns } from "./CourrierTypes.vue?vue&type=template&id=988fc2b8&scoped=true"
import script from "./CourrierTypes.vue?vue&type=script&lang=js"
export * from "./CourrierTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988fc2b8",
  null
  
)

export default component.exports